module.exports = __webpack_public_path__ + "img/1720x750px-Csarnok.4d14b49a.jpg";